import api from "@/api.js";
import { computed } from "vue";
import { ref } from "vue";
import { createGlobalState } from "@vueuse/core";
import cookie from "js-cookie";
import { useBookingFlow } from "@/stores/bookingFlowStore.js";
import { getSegmentId } from "@/helpers/segment/getSegmentId";
import { setSegmentId } from "@/helpers/segment/setSegmentId";
import { trackClientCreated } from "@/helpers/siteEvents";

export const useCreateClient = createGlobalState(() => {
  const status = ref("IDLE");
  const isLoading = computed(() => status.value === "PENDING");
  const isError = computed(() => status.value === "ERROR");
  const isSuccess = computed(() => status.value === "SUCCESS");
  const isIdle = computed(() => status.value === "IDLE");

  async function create({ phone, name, email, promocode, fb_pixel }) {
    cookie.set("client_phone_user_input", phone);
    if (email) localStorage.setItem("autobooking_email", email);

    const spainPhonePattern = /^(\+34|0034|34)?[6789]\d{8}$/;
    if (spainPhonePattern.test(phone)) {
      var cookieValue = cookie.get("distribution_tag_ids");
      var newArray;

      if (cookieValue) {
        newArray = JSON.parse(cookieValue);
        if (!Array.isArray(newArray)) {
          newArray = [];
        }
      } else {
        newArray = [];
      }

      newArray.push(1);
      cookie.set("distribution_tag_ids", JSON.stringify(newArray));
    }

    const spainPhoneSegment = new URL(document.location.href).searchParams.get(
      "spain_phone_segment"
    );
    if (
      spainPhoneSegment === "true" &&
      spainPhonePattern.test(phone) &&
      parseInt(getSegmentId()) === 14
    ) {
      setSegmentId("54");
    }

    const usaPhonePattern = /^(\+1|001|1)?[2-9]\d{9}$/;
    const segment = getSegmentId();
    var clientSegment = parseInt(segment)
    if (usaPhonePattern.test(phone) && clientSegment === 14) {
      var cookieValue = cookie.get("distribution_tag_ids");
      var newArray;

      if (cookieValue) {
        newArray = JSON.parse(cookieValue);
        if (!Array.isArray(newArray)) {
          newArray = [];
        }
      } else {
        newArray = [];
      }

      newArray.push(30);
      cookie.set("distribution_tag_ids", JSON.stringify(newArray));
    }

    const bookingFlow = useBookingFlow();
    status.value = "PENDING";
    const checkPhone = await api.checkPhone(phone);
    if (!checkPhone.id) {
      let dataObject = {
        name,
        phone,
        email,
        promocode,
        fb_pixel,
        landing_id: cookie.get("landing_id"),
        landing_type: cookie.get("landing_type"),
        landing_type_referrer: cookie.get("landing_type_referrer"),
        segment,
        feature_parameter: cookie.get("featureParameter"),
        acquisition_source: cookie.get("acquisition_source"),
        ref_code: cookie.get("ref_code")
      };

      const newClient = await api.newClient(dataObject);
      if (newClient === "error") {
        status.value = "ERROR";
      } else {
        trackClientCreated(newClient, true);
        cookie.set("client_id", newClient, { expires: 30 });
        cookie.set("client_phone", phone, { expires: 30 });
        cookie.set("client_promocode", promocode, { expires: 30 });
        bookingFlow.setParentInfo({
          client_id: newClient,
          client_phone: phone,
        });
        setTimeout(() => {
          status.value = "SUCCESS";
        });
      }
    } else {
      trackClientCreated(checkPhone.id, false);
      cookie.set("client_id", checkPhone.id, { expires: 30 });
      cookie.set("client_phone", phone, { expires: 30 });
      cookie.set("client_promocode", promocode, { expires: 30 });
      bookingFlow.setParentInfo({
        client_id: checkPhone.id,
        client_phone: phone,
      });
      setTimeout(() => {
        status.value = "SUCCESS";
      });
    }
  }

  return { isLoading, isError, isSuccess, isIdle, create };
});
